import { render, staticRenderFns } from "./Order-Details.vue?vue&type=template&id=1ace026a&scoped=true&"
import script from "./Order-Details.vue?vue&type=script&lang=js&"
export * from "./Order-Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ace026a",
  null
  
)

export default component.exports